import { useContext } from 'react';
import { Context, ContextValue } from './context';

export const useAnimatedRoutes = (): ContextValue => useContext(Context);
